export default __webpack_public_path__ + "static/media/prm-club-home.35df1bf5.png";